export default __webpack_public_path__ + "static/media/Aura-Egg__86.1b8d16db.png";